import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import {
  GridRow,
  GridColumn,
  Img,
  Label,
  Input,
  Select,
  Loader,
} from "arv-reactcomponents";
import { Endpoints, HIDE_BRANDNAME, SHOP_MULTILPE } from "npmlinks-constants";
import { PriceBlock, ColorsBlock } from "../../ProductList";
import Anchor from "../../Anchor";

@inject("BrandStore", "CommonStore")
@observer
class ProductItem extends Component {
  static getList(sku) {
    return <li className="nw-productitem-skuli">{sku.size}</li>;
  }
  static getQtyList(qty) {
    return <li className="nw-productitem-qtyli">{qty}</li>;
  }
  constructor() {
    super();
    this.state = {
      mainImage: null,
      errorImage: null,
    };
    this.toggleSelection = this.toggleSelection.bind(this);
    this.updateSku = this.updateSku.bind(this);
    this.updateQty = this.updateQty.bind(this);
    this.selectStyle = this.selectStyle.bind(this);
    this.setMainImage = this.setMainImage.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onImageError = this.onImageError.bind(this);
  }
  get image() {
    const { mainImage } = this.state;
    const { data } = this.props;
    return (
      mainImage ||
      (data && data.images && data.images[0] && data.images[0].medium) ||
      Endpoints.noImg
    );
  }
  get priceDetails() {
    const { data } = this.props;
    const { selectedSku, discountRange, mrpRange, sellingPriceRange } = data;
    return {
      selectedSku,
      discountRange,
      mrpRange,
      sellingPriceRange,
    };
  }
  get skuList() {
    const { data } = this.props;
    return data.skus && data.skus.filter(sku => sku.inStock);
  }
  get qtyList() {
    const { data } = this.props;
    const { selectedSku } = data;
    const sellableQuantity = (selectedSku && selectedSku.sellableQuantity) || 0;
    const maxQuantityDisplayed =
      (selectedSku && selectedSku.maxQuantityDisplayed) || 0;
    const returnValue =
      sellableQuantity < maxQuantityDisplayed
        ? sellableQuantity
        : maxQuantityDisplayed;
    return Array.from({ length: returnValue }, (v, k) => k + 1);
  }
  get outOfStock() {
    const { data } = this.props;
    return !data.inStock;
  }
  toggleSelection() {
    this.props.toggleSelection();
  }
  updateSku(sku) {
    const { data } = this.props;
    this.props.updateSku(data, sku);
  }
  updateQty(qty) {
    const { data } = this.props;
    this.props.updateQty(data, qty);
  }
  selectStyle(e, styleId) {
    const { data } = this.props;
    e.preventDefault();
    this.props.updateStyle(data, styleId);
  }
  setMainImage(image) {
    this.setState({ mainImage: image });
  }
  closeModal() {
    const { isDesktop } = this.props.CommonStore;
    if (!isDesktop) {
      this.props.closeModal();
    }
  }
  onImageError() {
    this.setState({ errorImage: Endpoints.noImg });
  }
  render() {
    const { data, index, loadingIndex } = this.props;
    const { isDesktop } = this.props.CommonStore;
    const { productsToBeSelected } = this.props.BrandStore;
    const { brandName, name, styleId, colors } = data;
    const { errorImage } = this.state;

    return (
      <div className={`nw-productitem-container item-${index}`}>
        {(loadingIndex === index || this.outOfStock) && (
          <div className="nw-productitem-loadercontainer nwc-translucentbackground-white ">
            {!this.outOfStock && <Loader />}
            {this.outOfStock && (
              <p className="nw-productitem-oostext">
                {SHOP_MULTILPE.SHOP_ALL_STYLES.OUT_OF_STOCK_TEXT}
              </p>
            )}
          </div>
        )}
        <div
          className="nw-productitem-toggle"
          role="presentation"
          onClick={this.toggleSelection}
          title={SHOP_MULTILPE.SHOP_ALL_STYLES.TOGGLE_TITLE}
        >
          <Label
            className="nw-productitem-togglelabel"
            htmlFor={`nw-productitem-togglelabel-${data.styleId}`}
          >
            <Input
              id={`nw-productitem-togglelabel-${data.styleId}`}
              className="nw-productitem-toggleinput"
              type="checkbox"
              value={index}
              checked={data.isSelected}
              name={data.styleId}
              onChange={this.toggleSelection}
            />
          </Label>
        </div>
        <GridRow
          className={`nw-productitem-items ${(productsToBeSelected &&
            data.isSelected &&
            !data.selectedSku &&
            "is-highlighted") ||
            ""}`}
        >
          <GridColumn className="nw-productitem-imagecontainer">
            <Anchor.component
              to={data.url}
              href={data.url}
              target={(isDesktop && "_blank") || ""}
              onClick={this.closeModal}
            >
              <Img
                className="nw-productitem-image"
                src={errorImage || this.image}
                onError={this.onImageError}
              />
            </Anchor.component>
          </GridColumn>
          <GridColumn>
            {!HIDE_BRANDNAME && (
              <h3 className="nw-productitem-brandname">{brandName}</h3>
            )}
            <p className="nw-productitem-productname">{name}</p>
            <PriceBlock.component
              {...this.priceDetails}
              className="nw-productitem-price"
            />
          </GridColumn>
          <GridColumn className="nwc-grid-col-xs-6 nw-productitem-skuselectcontainer">
            <div className="nw-productitem-selecttitle">
              {SHOP_MULTILPE.SHOP_ALL_STYLES.SIZE_TEXT}
            </div>
            <Select
              className="nwc-select-secondary nwc-select-sm nw-productitem-qtyselect nw-common-select"
              selectedValue={
                data.selectedSku ||
                SHOP_MULTILPE.SHOP_ALL_STYLES.DEFAULT_SKU_SELECT
              }
              inpList={this.skuList}
              getSelection={this.updateSku}
              renderList={ProductItem.getList}
              compareProp="size"
              disabled={!data.isSelected}
            />
          </GridColumn>
          <GridColumn className="nwc-grid-col-xs-6 nw-productitem-qtyselectcontainer">
            <div className="nw-productitem-selecttitle">
              {SHOP_MULTILPE.SHOP_ALL_STYLES.QTY_TEXT}
            </div>
            <Select
              className="nwc-select-secondary nwc-select-sm nw-productitem-qtyselect nw-common-select"
              selectedValue={data.selectedQty || 1}
              inpList={this.qtyList}
              getSelection={this.updateQty}
              disabled={!data.selectedSku || !data.isSelected}
              renderList={ProductItem.getQtyList}
            />
          </GridColumn>
          <GridColumn className="nw-productitem-colorscontainer">
            <ColorsBlock.component
              styleId={styleId}
              setStyle={this.selectStyle}
              setMainImage={this.setMainImage}
              ProductLoader={false}
              colors={colors}
              title={SHOP_MULTILPE.SHOP_ALL_STYLES.COLOR_TEXT}
            />
          </GridColumn>
        </GridRow>
      </div>
    );
  }
}

ProductItem.wrappedComponent.propTypes = {
  closeModal: PropTypes.func.isRequired,
  data: PropTypes.shape({}).isRequired,
  index: PropTypes.number.isRequired,
  toggleSelection: PropTypes.func.isRequired,
  updateSku: PropTypes.func.isRequired,
  updateQty: PropTypes.func.isRequired,
  updateStyle: PropTypes.func.isRequired,
  loadingIndex: PropTypes.number.isRequired,
  BrandStore: PropTypes.shape({
    productsToBeSelected: PropTypes.bool.isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};
const getFinalComponent = component =>
  inject("BrandStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ProductItem.wrappedComponent,
  component: ProductItem,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ShopMultiple/ProductItem/index.js